import axios from 'axios'
import store from '../store'
import router from '../router'
import { getToken, removeToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL, // api
  timeout: 60 * 1000 // seconds request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getToken('token-olsera')
    if (token) {
      if (store.getters['app/tokenOlsera']) {
        config.headers.Authorization = 'Bearer ' + token.access_token
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    let errorCode = 0
    let statusCode = 500
    const fallbackMessage = 'Request failed please try again'
    let message = fallbackMessage
    let string = fallbackMessage
    if (error.response) {
      const errorError = error.response.data.error.error
      let errArr = errorError
      string = errArr

      if (typeof errorError !== 'string') {
        string = ''
        errArr = Object.values(errorError)
        for (let index = 0; index < errArr.length; index++) {
          string += '- ' + errArr[index]
        }
      }

      if (error.response) {
        statusCode = error.response.data.error.status_code
        message = error.response.data.error.message
        errorCode = error.response.data.error.error_code
        if (errorCode === 1) {
          logoutApp()
        }
      } else {
        string = message
      }
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      statusCode,
      message,
      string,
      errorCode
    })
  }
)

const logoutApp = () => {
  removeToken('user-token')
  removeToken('token-olsera')
  location.reload()
  router.push({ path: '/login' })
}

export default service
